import WidgetPanel from "components/common/WidgetPanel";
import { connect } from "react-redux";
import PaymentCard from "interfaces/response/PaymentCard";
import Button from "components/common/controls/Button";
import { getDefaultPaymentCardDetail } from "store/slices/InvoiceSlice";
import { AppDispatch, RootState } from "store/store";
import { useEffect, useState } from "react";
import { getStripeBillingPortalSession } from "apis/StripeSessionApi";
import StripeBillingPortalSessionRequest from "interfaces/request/StripeBillingPortalSessionRequest";
import moment from "moment";
import Loader from "components/common/controls/Loader";

interface Props {
  cardDetail?: PaymentCard | null;
  userName?: string;
  loadCardDetail?: () => void;
}

export function PaymentCardDetail(props: Props) {
  const { cardDetail, userName, loadCardDetail } = props;
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadCardDetail?.();
  }, [loadCardDetail]);

  const handleUpdateCardClick = () => {
    setIsLoading(true);
    const billingPortalSessionRequest: StripeBillingPortalSessionRequest = {
      returnUrl: window.location.href,
    };

    getStripeBillingPortalSession(billingPortalSessionRequest)
      .then((session) => {
        setIsLoading(false);
        window.open(session.url, "_self");
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const getCardExpirationMonthAndYear = () => {
    if (cardDetail && cardDetail.expirationMonth && cardDetail.expirationYear) {
      const expirationDate = moment();
      expirationDate.set("year", cardDetail.expirationYear);
      expirationDate.set("month", cardDetail.expirationMonth);
      // Display month and year only. Date is not considered.
      return expirationDate.format("MM/YYYY");
    }

    return "";
  };

  return (
    <WidgetPanel title="Invoices">
      <div className="flex border border-silver rounded-lg w-3/4">
        <div className="w-1/2 border-r border-silver p-4">
          {cardDetail ? (
            <>
              <div>
                <span className="font-bold">{cardDetail.brand}</span> ending in{" "}
                <span className="font-bold">{cardDetail.lastDigits}</span>
              </div>
              <div className="mt-3 text-sm">
                {cardDetail.customerName || userName}
              </div>
            </>
          ) : (
            <>
              <div className="font-bold mb-1">No card information</div>
              <div>Please add a default card for your automatic payments.</div>
            </>
          )}
        </div>
        <div className="w-1/2 p-4">
          {cardDetail && (
            <div className="float-left inline-block">
              Expires
              <div className="mt-3 text-sm">
                {getCardExpirationMonthAndYear()}
              </div>
            </div>
          )}
          <div className="h-full float-right inline-block flex items-center justify-center">
            <Button
              text={cardDetail ? "UPDATE CARD" : "ADD CARD"}
              onClick={handleUpdateCardClick}
            />
          </div>
        </div>
      </div>
      <Loader isVisible={isLoading} />
    </WidgetPanel>
  );
}

const mapStateToProps = (state: RootState) => {
  return {
    userName: state.userData?.currentUserDetail?.fullName,
    cardDetail: state.invoiceData.invoiceCardDetail,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    loadCardDetail: () => dispatch(getDefaultPaymentCardDetail()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentCardDetail);
